import * as z from 'zod';

export function validateLength(value: unknown): boolean {
    if (typeof value === 'number') {
        return true;
    }
    if (
        z
            .object({
                value: z.number(),
                unit: z.string(),
            })
            .validate(value)
    ) {
        return true;
    }
    return false;
}
